import React from 'react';
import classnames from 'classnames';
import { isColorDark, fixColor } from '@/utils';
import { ModuleBaseModel, ModuleBasePropsModel } from '@/types';

export interface IModuleBaseProps<
  T extends ModuleBaseModel<ModuleBasePropsModel>,
> extends React.HTMLAttributes<HTMLElement> {
  data: T;
  className?: string;
  tag?: string;
  noPadding?: boolean;
  noModuleBaseColor?: boolean;
  style?: React.CSSProperties;
}

const ModuleBase = ({
  data,
  style,
  className,
  tag,
  noPadding,
  noModuleBaseColor = false,
  ...otherProps
}: IModuleBaseProps<ModuleBaseModel<ModuleBasePropsModel>>) => {
  const { props, moduleName } = data;
  const classes = ['module', className];

  const backgroundColor = fixColor(props?.backgroundColour);

  if (!props?.noPaddingOnTop && !noPadding) {
    classes.push('pt-8 md:pt-12 print:pt-5');
  }

  if (!props?.noPaddingOnBottom && !noPadding) {
    classes.push('pb-8 md:pb-12 print:pb-5');
  }

  if (!noModuleBaseColor && !className?.includes('module-base-dark') && !className?.includes('module-base-light')) {
    if (isColorDark(backgroundColor)) {
      classes.push('module-base-light');
    } else {
      classes.push('module-base-dark');
    }
  }

  classes.push(moduleName || undefined);

  return React.createElement(tag?.toLowerCase() || 'section', {
    id: props?.anchor || null,
    style: {
      backgroundColor,
      ...style,
    },
    className: classnames(classes),
    ...otherProps,
  });
};

export default ModuleBase;
